/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, themeStyleHelper, disable } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// LINK STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library))
export default theme => ({
	link: {
		cursor: 'pointer',
		transition: theme.animation.general('all'),
		display: 'inline-flex',
		whiteSpace: 'nowrap',
		'& .inner': {
			display: 'inline-flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		// loader
		'& .loader': {
            display: 'none',
            fontSize: '38%',
            marginRight: pxToEm(15),
            '& div': { borderTopColor: theme.color.primary.medium.swatch }
        },
		'& a': {
			color: 'inherit',
			display: 'flex',
			alignItems: 'center'
		},
		'&.icon-true': {
			'& .icon': { marginRight: pxToEm(10) },
			'&.iconRight-true': {
				'& .text': { order: '-1' },
				'& .icon': { marginRight: '0', marginLeft: pxToEm(10) }
			},
			'&.iconOnly-true': {
				'& .text': { display: 'none' },
				'& .icon': { marginRight: '0', marginLeft: '0' }
			}
		},
		'&.underline-true': {
			textDecoration: 'underline'
		},
		'&.isActive-true':{
			cursor: 'default',
			pointerEvents: 'none',
		},
		'&.disabled-true':{
			extend: disable
		},
		'&.processing-true': {
			cursor: 'default',
			pointerEvents: 'none',
            '& .loader': {
                display: 'inline-block'
            }
        },

		// ----- divider ----- //
		'& .divider': {
			color: 'inherit',
			display: 'inline-flex',
			height: '100%',
			width: pxToEm(1),
			marginLeft: pxToEm(10),
			marginRight: pxToEm(10)
		},

		// ----- colors ----- //
		// generates classes for every color in the theme ".color-(uniqueColor)"
		extend: themeStyleHelper(theme, 'color', (theme, uniqueColor) => {
			return {
				color: theme.color[uniqueColor].medium.swatch,
				'& .loader div': { borderTopColor: theme.color[uniqueColor].medium.swatch }
			}
		}),

		// +++++ states +++++ //
		'&:hover': {
			filter: 'brightness(85%)'
		}
	}
});